import { Suspense } from 'react';
//@ts-ignore
import OnReactIdle from '@modus/react-idle';

export type TOnIdleProps = {
  children: JSX.Element | JSX.Element[];

  // Show a placeholder until children are rendered
  placeholder?: JSX.Element;

  // Fires when content is rendered, but only if onIdle was used
  onRender?: () => void;

  // Don't render component if Server Side Rendering is used
  skipSSR?: boolean;

  // True to render updates synchronously, without onIdle
  // Default: false to render updates when browser becomes idle
  syncUpdate?: boolean;

  // wrap children with suspense
  withSuspense?: boolean;
};

const OnIdle = (props: TOnIdleProps) => {
  const { withSuspense = true, placeholder = null, children, syncUpdate = true, ...rest } = props;

  if (withSuspense) {
    return (
      <OnReactIdle {...rest} placeholder={placeholder} syncUpdate={syncUpdate}>
        <Suspense fallback={placeholder}>{children}</Suspense>
      </OnReactIdle>
    );
  }
  return <OnReactIdle {...props} />;
};

export default OnIdle;
